import React from 'react';
import '../../admin-stats.css';

function ContentStatsChart({ contentData, loading }) {
  if (loading || !contentData) {
    return (
      <div className="stats-section">
        <h2>Content Statistics</h2>
        <div className="loading">Loading content data...</div>
      </div>
    );
  }

  const stats = contentData;

  return (
    <div className="stats-section">
      <h2>📄 Content Statistics</h2>
      
      <div className="stats-grid">
        <div className="stat-box">
          <h3>Content Summary</h3>
          <div className="breakdown-list">
            <div className="breakdown-item">
              <span className="label">Total Content</span>
              <span className="value">{stats.summary?.total || 0}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">Published</span>
              <span className="value positive">{stats.summary?.published || 0}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">Hidden</span>
              <span className="value warning">{stats.summary?.hidden || 0}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">Hidden %</span>
              <span className="value">{stats.summary?.hidden_percentage || 0}%</span>
            </div>
          </div>
        </div>

        <div className="stat-box">
          <h3>By Type</h3>
          <div className="breakdown-list">
            {stats.byType && Object.entries(stats.byType).map(([type, data]) => (
              <div key={type} className="breakdown-item">
                <span className="label">{type}</span>
                <span className="value">{data.total}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="stat-box">
          <h3>Publishing Trends</h3>
          <div className="breakdown-list">
            <div className="breakdown-item">
              <span className="label">This Month</span>
              <span className="value">{stats.publishingTrends?.thisMonth || 0}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">Last Month</span>
              <span className="value">{stats.publishingTrends?.lastMonth || 0}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">Growth Rate</span>
              <span className={`value ${stats.publishingTrends?.growthRate > 0 ? 'positive' : 'negative'}`}>
                {stats.publishingTrends?.growthRate || 0}%
              </span>
            </div>
          </div>
        </div>

        <div className="stat-box">
          <h3>View Metrics</h3>
          <div className="breakdown-list">
            <div className="breakdown-item">
              <span className="label">No Views</span>
              <span className="value warning">{stats.contentWithNoViews || 0}</span>
            </div>
            <div className="breakdown-item">
              <span className="label">High Views (100+)</span>
              <span className="value positive">{stats.contentWithHighViews || 0}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="stat-box full-width">
        <h3>Top Content by Views</h3>
        {stats.topContent && stats.topContent.length > 0 ? (
          <div className="table-container">
            <table className="stats-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Type</th>
                  <th>Views</th>
                  <th>Unique Viewers</th>
                </tr>
              </thead>
              <tbody>
                {stats.topContent.map((content, idx) => (
                  <tr key={idx}>
                    <td>{content.title}</td>
                    <td>{content.type}</td>
                    <td className="text-right">{content.viewCount}</td>
                    <td className="text-right">{content.uniqueViewers}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="empty-state">No content data available</p>
        )}
      </div>

      {stats.timeSeries && stats.timeSeries.length > 0 && (
        <div className="stat-box full-width">
          <h3>Publishing Timeline</h3>
          <div className="timeline-container">
            {stats.timeSeries.map((item, idx) => (
              <div key={idx} className="timeline-item">
                <span className="timeline-date">{item.date}</span>
                <span className="timeline-value">{item.newContent} new</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ContentStatsChart;
